import { Inject, Injectable } from '@angular/core';
import { LIB_CONFIG } from '@challenger/care/lib-config';
import { LibConfig } from '@challenger/care/models/lib-config.model';
import { Apollo, gql } from 'apollo-angular';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavContentStrapiService {
  strapiUrl = this?.config?.strapiURL;
  constructor(private apollo: Apollo, @Inject(LIB_CONFIG) private config: LibConfig) {}

  getNavigation(): Observable<any> {
    const GET_NAVIGATION = gql`
      query PageQuery {
        navigations(where: { level: 10 }) {
          id
          title
          externalUrl
          displayOrder
          leftIcon: icon_class
          icon {
            url
          }
          children: sub_navigations {
            id
            title
            externalUrl
            displayOrder
            leftIcon: icon_class
            icon {
              url
            }
            type
            children: sub_navigations {
              title
              externalUrl
              displayOrder
              leftIcon: icon_class
              icon {
                url
              }
              type
            }
          }
          parent_navigation {
            uid
          }
        }
      }
    `;
    return this.apollo
      .watchQuery({
        query: GET_NAVIGATION,
      })
      .valueChanges.pipe(
        map((navigationData) => ({
          ...navigationData,
        }))
      );
  }
}
